import type { TicketStatus } from '@/types/ticket'
import { STAFF_SET_STATUSES, statusLabels } from '@/lib/status'
import { railSelectClass } from './railSelect'

// Staff can set any stored status (Open, On Hold, Resolved, Closed); the derived ones show as the
// pill. A pre-migration status stays listed so it reads correctly until changed. A tracked ticket's
// status follows its tracker status instead.
export function StatusSelect({
  value,
  onChange,
  disabled,
  tracked = false,
}: {
  value: TicketStatus
  onChange: (s: TicketStatus) => void
  disabled?: boolean
  tracked?: boolean
}) {
  const options: TicketStatus[] = tracked ? [value] : STAFF_SET_STATUSES.includes(value) ? STAFF_SET_STATUSES : [value, ...STAFF_SET_STATUSES]
  return (
    <select
      aria-label="Status"
      title={tracked ? 'Follows the tracker status' : undefined}
      disabled={disabled || tracked}
      value={value}
      onChange={e => onChange(e.target.value as TicketStatus)}
      className={railSelectClass}
    >
      {options.map(s => <option key={s} value={s}>{statusLabels[s]}</option>)}
    </select>
  )
}
